const productWrapper = document.querySelectorAll('.product-converter__content')
const productCards = document.querySelectorAll('.c-product-card')

const numberWithCommas = (x) => {
  return x
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

let price = null
let variantSelector = null

//for product page
if (productWrapper.length === 1) {
  const priceSelector = productWrapper[0].querySelector('.price__sale')
  price = parseInt(priceSelector.getAttribute('data-price')) / 100.0

  variantSelector = productWrapper[0].querySelector('.select select')
  variantSelector?.addEventListener('change', (e) => {
    productWrapper[0].querySelector('input[name="id"]').value = e.target.value

    const selectedPrice =
      e.target.options[e.target.selectedIndex].text.split(' - ')[1]
    priceSelector.textContent = selectedPrice
  })
}

if (productCards.length) {
  productCards.forEach((productCard) => {
    const priceSelector = productCard.querySelector('.price__sale')
    if (priceSelector)
      price = parseInt(priceSelector.getAttribute('data-price')) / 100.0

    variantSelector = productCard.querySelector('.select select')
    variantSelector?.addEventListener('change', (e) => {
      productCard.querySelector('input[name="id"]').value = e.target.value
      const selectedPrice =
        variantSelector.options[variantSelector.selectedIndex].text.split(
          ' - '
        )[1]
      if (priceSelector) priceSelector.textContent = selectedPrice
    })
  })
}
